import axios from 'axios';
import config from '../utils/config';
import { LEGAL_VERSION } from './consent';
import { readPreferredLanguage } from '../utils/languagePreference';
import { readWithRecovery } from '../utils/loadWithRecovery';

// Called only when a checked registration form starts an OAuth attempt. The
// snapshot travels with that attempt's expiring state, never with the account cache.
export const registrationConsent = () => ({ version: LEGAL_VERSION, terms: true, opinions: true, ai: true,
  language: readPreferredLanguage() });

export async function saveRegistrationConsent(token, consent, { signal } = {}) {
  if (consent?.version !== LEGAL_VERSION || ['terms', 'opinions', 'ai'].some(key => consent[key] !== true)) {
    throw new Error('REGISTRATION_CONSENT_REQUIRED');
  }
  const result = await axios.put(`${(process.env.REACT_APP_API_URL || '').replace(/\/$/, '')}/user/legal-consent`,
    { version: LEGAL_VERSION, terms: true, opinions: true, ai: true },
    { headers: { [config.token]: token }, signal, timeout: 15000 });
  if (!result.data?.success) throw new Error('REGISTRATION_CONSENT_FAILED');
}

// A legacy session without a versioned record returns to the registration
// checkbox before interactive content, never at the first vote/upload. An
// explicit withdrawal is an existing record and must not be treated as missing.
export async function readRegistrationStatus(token, signal) {
  const result = await readWithRecovery(options => axios.get(`${(process.env.REACT_APP_API_URL || '').replace(/\/$/, '')}/user/legal-consent`,
    { headers: { [config.token]: token }, ...options }), { signal });
  if (!result.data?.success || result.data.version !== LEGAL_VERSION || !result.data.consent) throw new Error('Registration status unavailable');
  return result.data.registration_required === true;
}
